import { forwardRef } from "react";
import { Any } from "@cede/types";
import { cn } from "@/lib/utils";

export type PageProps = {
  displayFlex?: boolean;
  onSubmit?: React.FormEventHandler<Any>;
  className?: string;
} & React.HTMLAttributes<HTMLDivElement>;

export const Page = forwardRef<HTMLDivElement, PageProps>(({ children, displayFlex, className, ...divProps }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        "h-full w-full pb-0 p-1",
        displayFlex && "flex flex-col justify-between",
        "[&::-webkit-scrollbar]:w-1",
        "[&:hover::-webkit-scrollbar-thumb]:bg-white",
        "[&::-webkit-scrollbar-thumb]:rounded",
        className,
      )}
      {...divProps}
    >
      {children}
    </div>
  );
});

Page.displayName = "Page";
